import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { ITenantSettingsChangedNotification } from '@nimbus-global/features/signalr/models/tenant-settings-changed-notification.model';

@Injectable({ providedIn: 'root' })
export class TenantRealtimeSettingsApiClient {
  public constructor(private readonly httpService: BaseHttpService) {}

  public getTenantRealtimeSettings(tenantId: string): Observable<ITenantSettingsChangedNotification> {
    return this.httpService.get(`organization-unit-manager/v2/Tenants/${encodeURIComponent(tenantId)}/realtime-settings`);
  }
}
